// extracted by mini-css-extract-plugin
module.exports = {"headerText":"OfferCard_headerText__3cgSR","continueText":"OfferCard_continueText__28B-d","footerDays":"OfferCard_footerDays__2vbiz","h3":"OfferCard_h3__uJmPg"};